"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _orderBy2 = _interopRequireDefault(require("lodash/orderBy"));

var _each2 = _interopRequireDefault(require("lodash/each"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactGridLayout = require("react-grid-layout");

require("react-grid-layout/css/styles.css");

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ReactGridLayoutResponsive = (0, _reactGridLayout.WidthProvider)(_reactGridLayout.Responsive);
var DEFAULT_ROW_HEIGHT = 295; // This is the default break point for Prism home page dashboard.

var DASHBOARD_HOME_PAGE_BREAK_POINTS = {
  lg: 1700,
  md: 1280,
  sm: 965,
  xsm: 650,
  xxsm: 439
}; // Based on the above break points each key/value indicate
// how many columns to show.

var DASHBOARD_HOME_PAGE_COLS = {
  lg: 4,
  md: 4,
  sm: 3,
  xsm: 2,
  xxsm: 1
};
/**
 * Default props for each item in the layouts
 * See https://github.com/STRML/react-grid-layout#responsive-grid-layout-props
 * for the expected shape.
 */

var LAYOUT_DEFAULT_PROPS = {
  x: 0,
  y: 0,
  w: 1,
  h: 1,
  static: true
};
/**
 * This is the main Xi style Dashboard.  It uses react-grid-layout
 * component.
 * https://github.com/STRML/react-grid-layout#grid-layout-props
 * The responsive positioning strategy used in this component is a bit
 * different than how React-Grid-Layout is doing it.  The layout will attempt
 * to layout each item with priority of left to right and the top to
 * bottom.
 *
 * TODO: Currently resizing and respositioning is a bit strange due to the
 * way react-grid-layout shuffling tiles around.  This need to be fix if we
 * want to make use of customize dashboard.
 */

var Dashboard =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Dashboard, _React$Component);

  function Dashboard(props) {
    var _this;

    _classCallCheck(this, Dashboard);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dashboard).call(this, props));

    _this.handleOnLayoutChange = function (layout, layouts) {
      _this.setState({
        layouts: _this.initLayouts(layouts)
      });

      if (_this.props.onLayoutChange) {
        _this.props.onLayoutChange(layout, layouts);
      }
    };

    _this.state = {
      layouts: _this.initLayouts(props.layouts)
    };
    return _this;
  }
  /**
   * Initialized the layouts object.
   * @param {object} layouts - See props.layouts
   * @returns {object} - return the inited layout objects.
   */


  _createClass(Dashboard, [{
    key: "initLayouts",
    value: function initLayouts(layouts) {
      var _this2 = this;

      // Fills in the default grid item properties for each of the layout.
      var initLayouts = {};
      (0, _each2.default)(layouts, function (layout, breakpoint) {
        var initLayout = layout.map(function (layoutItem) {
          return _objectSpread({}, LAYOUT_DEFAULT_PROPS, {}, layoutItem);
        });
        initLayouts[breakpoint] = _this2.sortLayoutItems(initLayout);
      }); // The initial layouts from props doesn't require all the various
      // breakpoint layout defined.  This will fill in those gap.

      var firstLayout = initLayouts[Object.keys(initLayouts)[0]];
      var mergedLayouts = {};
      (0, _each2.default)(this.props.cols, function (cols, breakpoint) {
        mergedLayouts[breakpoint] = _this2.initLayoutPositioning(initLayouts[breakpoint] || firstLayout, cols);
      });
      return mergedLayouts;
    }
    /**
     * Give a layout initialize the positions for each layout items.
     * This layout the items from left to right and top to bottom.
     * @param {array} layout - array of grid items.
     * @param {number} cols - number of column position this layout
     * @returns {array} - initialized layout
     */

  }, {
    key: "initLayoutPositioning",
    value: function initLayoutPositioning(layout, cols) {
      var currX = 0,
          currY = 0,
          currH = 0;
      return layout.map(function (layoutItem) {
        var newLayoutItem = _objectSpread({}, layoutItem);

        if (newLayoutItem.w > cols) {
          newLayoutItem.w = cols;
        } // If the current X position + the layout item width
        // is larger than the max columns then bump this item
        // down to the next Y position.


        if (currX + newLayoutItem.w > cols) {
          currX = 0;
          newLayoutItem.x = 0;
          newLayoutItem.y = currH;
          currY = currH;
          currH = 0;
        } else {
          newLayoutItem.x = currX;
          newLayoutItem.y = currY;
        }

        currX += newLayoutItem.w;

        if (currH < newLayoutItem.h) {
          currH = currY + newLayoutItem.h;
        }

        return newLayoutItem;
      });
    }
    /**
     * Sort the layout( array of grid items ).
     * @param {array} layout - array of grid item
     * @returns {array} - sorted layout.
     */

  }, {
    key: "sortLayoutItems",
    value: function sortLayoutItems(layout) {
      // Each item in the layouts has a x(col) and y(row) position.
      // 0, 0 is top left corner on the dashboard.
      // This is doing a sort by row in ascending order followed by sort by column
      // in ascending order.
      var sorted = (0, _orderBy2.default)(layout, ['y', 'x'], ['asc', 'asc']);
      return sorted;
    }
    /**
     * Handler for when layout is changed.
     * @param {array} layout - The changed layout.
     * @param {object} layouts - The changed layouts
     */

  }, {
    key: "render",
    value: function render() {
      // layouts is set in the state
      // onLayoutChange is used in handleOnLayoutChange
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props,
          className = _this$props.className,
          layouts = _this$props.layouts,
          onLayoutChange = _this$props.onLayoutChange,
          wrapperProps = _this$props.wrapperProps,
          props = _objectWithoutProperties(_this$props, ["className", "layouts", "onLayoutChange", "wrapperProps"]);

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      return _react.default.createElement("div", _extends({
        className: (0, _classnames.default)("".concat(clsPrfx, " ").concat(clsPrfx, "-dashboard"), className)
      }, wrapperProps), _react.default.createElement(ReactGridLayoutResponsive, _extends({
        layouts: this.state.layouts,
        onLayoutChange: this.handleOnLayoutChange
      }, props), props.children));
    }
  }]);

  return Dashboard;
}(_react.default.Component);

exports.default = Dashboard;
Dashboard.defaultProps = {
  rowHeight: DEFAULT_ROW_HEIGHT,
  margin: [20, 20],
  breakpoints: DASHBOARD_HOME_PAGE_BREAK_POINTS,
  cols: DASHBOARD_HOME_PAGE_COLS
};
/* eslint-disable react/no-unused-prop-types */

Dashboard.propTypes = {
  /**
   * Customize additional class name.
   */
  className: _propTypes.default.string,

  /**
   * Each object must contain individual layout for
   * each responsive screen size lg, md, sm, xs, xxs.
   * See https://github.com/STRML/react-grid-layout#responsive-grid-layout-props
   * format.
   *
   * {lg: Layout, md: Layout...}  At least one of the size is needed.
   *
   * Layout is an array of items where each item shape as follow
   * {h: height unit, w: width unit, x: column position, y: position}
   * https://github.com/STRML/react-grid-layout#grid-item-props
   *
   * NOTE: x, y positioning in the layout item is only used as hint for the
   * placement and not meant to be exact position.  By default if x and y
   * position is not specified then it will be assigned to 0, 0(top left corner)
   * The responsive dashboard will attempt to place these items starting
   * at the top left corner and fill each item in as it move down the row.
   */
  layouts: _propTypes.default.object.isRequired,

  /**
   * Each children element in the array must contains a unique 'key'
   * that matches with the layout.i key.
   */
  children: _propTypes.default.arrayOf(_propTypes.default.element.isRequired).isRequired,

  /**
   * Number of px.  The actual height of the item is rowHeight per unit layout.h
   * See https://github.com/STRML/react-grid-layout#grid-layout-props
   * for a list of other properties.
   */
  rowHeight: _propTypes.default.number,

  /**
   * This is the breakpoint -> cols map.
   * https://github.com/STRML/react-grid-layout#responsive-grid-layout-props
   */
  cols: _propTypes.default.object,

  /**
   * Responsive object breakpoints
   * See https://github.com/STRML/react-grid-layout#responsive-usage
   * for more details.
   */
  breakpoints: _propTypes.default.object,

  /**
   * The [vertical, horizontal] margin in pixel placed between each widget.
   */
  margin: _propTypes.default.array,

  /**
   * Callback for when a layout is changed.
   * onLayoutChange(layout = this is the layout that changed, layouts)
   */
  onLayoutChange: _propTypes.default.func,

  /**
   * Props to be passed to wrapping dom element
   */
  wrapperProps: _propTypes.default.object
};
/* eslint-enable react/no-unused-prop-types */